/* Variant-aware product media filtering (added Aug 2026).
   Shows only the media that belongs to the selected colourway.

   Ownership is tagged server-side per item via data-luje-color (see
   snippets/luje-media-color.liquid); the variant-id → colour map sits on
   .sf-prod-media__wrapper as data-luje-variant-colors. The theme updates the
   product form's [name="id"] input silently (no events), so changes are
   picked up by option-click delegation plus a light polling safety net.

   Fail-safes: a colour that owns no media shows everything; missing map,
   input or wrapper means no filtering at all — never a blank gallery. */
(function () {
  'use strict';

  function init(scope) {
    var wrapper = scope.querySelector('[data-luje-variant-colors]');
    if (!wrapper || wrapper.dataset.lujeMediaInit) return;
    var map;
    try { map = JSON.parse(wrapper.getAttribute('data-luje-variant-colors')); } catch (e) { return; }
    var form = scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var input = form && form.querySelector('[name="id"]');
    if (!input) return;
    wrapper.dataset.lujeMediaInit = '1';

    /* 25 Aug 2026 (catalog-model review): Itsperfect now syncs one product
       per colour, so on the whole live catalog every variant maps to the
       same colourway and there is nothing to filter - the interval and
       listeners below would idle forever. Bail out entirely when the map has
       at most one distinct colour; the machinery stays for any future
       product that genuinely carries multiple colourways. */
    var distinct = {};
    for (var k in map) { if (Object.prototype.hasOwnProperty.call(map, k)) distinct[map[k]] = 1; }
    if (Object.keys(distinct).length <= 1) return;

    var grid = wrapper.querySelector('[data-luje-desktop-grid]');
    var deskItems = grid ? [].slice.call(grid.querySelectorAll('[data-luje-color]')) : [];
    var mobContainer = wrapper.querySelector('.sf-product-media__mobile .swiper-container');
    var mobWrapper = mobContainer && mobContainer.querySelector('.swiper-wrapper');
    var mobSlides = mobWrapper ? [].slice.call(mobWrapper.querySelectorAll('.swiper-slide[data-luje-color]')) : [];
    var last = null;

    function visibleFor(items, color) {
      var owned = items.some(function (el) { return el.getAttribute('data-luje-color') === color; });
      if (color === 'all' || !owned) return items;
      return items.filter(function (el) {
        var c = el.getAttribute('data-luje-color');
        return c === 'all' || c === color;
      });
    }

    function apply(color) {
      if (!color || color === last) return;
      last = color;

      if (deskItems.length) {
        var show = visibleFor(deskItems, color);
        deskItems.forEach(function (el) {
          el.style.display = show.indexOf(el) === -1 ? 'none' : '';
        });
        if (grid) {
          var multi = show.length > 1;
          grid.classList.toggle('grid-cols-2', multi);
          // The column count just changed, so every gallery image is now
          // painting at a different width. `sizes` is stated server-side (no
          // lazysizes measuring here), so it does not follow on its own —
          // without this, dropping to one column leaves the image declaring
          // half the width it occupies and the browser keeps the small
          // candidate it already chose.
          var attr = multi ? 'data-luje-sizes-multi' : 'data-luje-sizes-single';
          var next = grid.getAttribute(attr);
          if (next) {
            show.forEach(function (el) {
              var img = el.querySelector('img[srcset]');
              if (img && img.getAttribute('sizes') !== next) img.setAttribute('sizes', next);
            });
          }
        }
      }

      if (mobWrapper && mobSlides.length) {
        var mShow = visibleFor(mobSlides, color);
        mobSlides.forEach(function (el) {
          if (el.parentNode === mobWrapper) mobWrapper.removeChild(el);
        });
        mShow.forEach(function (el) { mobWrapper.appendChild(el); });
        var sw = mobContainer.swiper;
        if (sw) {
          sw.update();
          sw.slideTo(0, 0);
          if (sw.pagination) {
            if (sw.pagination.render) sw.pagination.render();
            if (sw.pagination.update) sw.pagination.update();
          }
        }
      }
    }

    function current() { return map[input.value] || null; }

    scope.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-value], .product-option-item, select')) {
        setTimeout(function () { apply(current()); }, 60);
        setTimeout(function () { apply(current()); }, 300);
      }
    });
    setInterval(function () { apply(current()); }, 400);
    apply(current());
  }

  function boot() {
    var sections = document.querySelectorAll('[data-section-type="product-page"]');
    if (sections.length) [].forEach.call(sections, init);
    else init(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
